import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    budgets: [],
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getMonitoring({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.purchasingOrder
        .getMonitoring(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getNonPO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.purchasingOrder
        .getNonPO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getHistoryLog({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.purchasingOrder
        .getHistoryLog(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    detailHistory({ commit }, id) {
      commit(mutations.LOADING);
      return api.purchasingOrder
        .getDetailHistory(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    completePO({ commit }, id) {
      commit(mutations.LOADING);
      return api.purchasingOrder
        .completePO(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    uncompletePO({ commit }, id) {
      commit(mutations.LOADING);
      return api.purchasingOrder
        .uncompletePO(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    uploadPoComplete({ commit }, payload) {
      commit(mutations.LOADING);
      return api.purchasingOrder
        .uploadPoComplete(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getFilteredPO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.purchasingOrder
        .getFilteredPO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getFilteredNonPO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.purchasingOrder
        .getFilteredNonPO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {}
};
